import React from "react";
import { unsetUser, State } from "@store";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Box, Button, Tooltip, Typography } from "@material-ui/core";

export const User: React.FC = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: State) => state.user);
  const onSignOutClick = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();
    dispatch(unsetUser());
  };

  return (
    <Box ml={2}>
      <Tooltip
        arrow
        title={
          <React.Fragment>
            <Box textAlign="right" p={2} color="white">
              <Typography variant="subtitle2">{user?.name!}</Typography>
              <Typography variant="caption" component="p" paragraph>
                <em>{user?.email}</em>
              </Typography>
              <Button
                color="inherit"
                variant="outlined"
                onClick={onSignOutClick}
              >
                Log out
              </Button>
            </Box>
          </React.Fragment>
        }
        interactive
        placement="bottom-end"
      >
        <Avatar alt={user?.name} src={user?.avatar} />
      </Tooltip>
    </Box>
  );
};
